var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiltersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FDFFFD",
  d: "M10.997 20a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712v-6l-5.8-7.4q-.375-.5-.112-1.05T4.997 4h14q.65 0 .913.55.262.55-.113 1.05l-5.8 7.4v6q0 .424-.287.712a.97.97 0 0 1-.713.288zm1-7.7 4.95-6.3h-9.9z"
}))));
export { SvgFiltersIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzMyMjBfOTI2NiIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRDlEOUQ5Ii8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8zMjIwXzkyNjYpIj4KPHBhdGggZD0iTTEwLjk5NzIgMjBDMTAuNzEzOCAyMCAxMC40NzYzIDE5LjkwNDIgMTAuMjg0NyAxOS43MTI1QzEwLjA5MyAxOS41MjA4IDkuOTk3MTUgMTkuMjgzMyA5Ljk5NzE1IDE5VjEzTDQuMTk3MTUgNS42QzMuOTQ3MTUgNS4yNjY2NyAzLjkwOTY1IDQuOTE2NjcgNC4wODQ2NSA0LjU1QzQuMjU5NjUgNC4xODMzMyA0LjU2MzgyIDQgNC45OTcxNSA0SDE4Ljk5NzJDMTkuNDMwNSA0IDE5LjczNDcgNC4xODMzMyAxOS45MDk3IDQuNTVDMjAuMDg0NyA0LjkxNjY3IDIwLjA0NzIgNS4yNjY2NyAxOS43OTcyIDUuNkwxMy45OTcyIDEzVjE5QzEzLjk5NzIgMTkuMjgzMyAxMy45MDEzIDE5LjUyMDggMTMuNzA5NyAxOS43MTI1QzEzLjUxOCAxOS45MDQyIDEzLjI4MDUgMjAgMTIuOTk3MiAyMEgxMC45OTcyWk0xMS45OTcyIDEyLjNMMTYuOTQ3MiA2SDcuMDQ3MTVMMTEuOTk3MiAxMi4zWiIgZmlsbD0iI0ZERkZGRCIvPgo8L2c+Cjwvc3ZnPgo=";